export const SENTRY_IGNORE_ERRORS = [
  // Random plugins/extensions
  "top.GLOBALS",
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  "originalCreateNotification",
  "canvas.contentDocument",
  "MyApp_RemoveAllHighlights",
  "http://tt.epicplay.com",
  "Can't find variable: ZiteReader",
  "jigsaw is not defined",
  "ComboSearch is not defined",
  "http://loading.retry.widdit.com/",
  "atomicFindClose",
  // Facebook borked
  "fb_xd_fragment",
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
  // reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268
  "bmi_SafeAddOnload",
  "EBCallBackMessageReceived",
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  "conduitPage",
  // google translate throws it.
  "a[b].target.className.indexOf is not a function",
  // react-animate-on-scroll throws it.
  "this.node is null",
  "Cannot read property 'clientHeight' of undefined",
  "Cannot read property 'clientHeight' of null",
  "null is not an object (evaluating 'this.node.clientHeight')",
  "Cannot read properties of null (reading 'clientHeight')",
  //
  "UET is not defined",
  // new Deployment time errros
  "Network Error",
  "Request failed with status code 500",
  "Request failed with status code 503",
  "Request failed with status code 504",
  "Request failed with status code 400",
  "Request failed with status code 403",
  "Request failed with status code 404",
  "Request failed with status code 405",
  //
  "Unable to find node on an unmounted component.",
  "Unable to find node on an unmounted component",
  //
  "this.remove is not a function",
  "Cannot read property '_avast_submit' of undefined",
  "Blocked a frame with origin",
  // Buyhatke
  "NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
  "Custom Redirect",
  "Cannot read property 'child' of null",
  "null is not an object (evaluating 'elt.parentNode')",
  // https://stackoverflow.com/a/60860369/2980047
  "TypeError: Failed to fetch",
  "TypeError: NetworkError when attempting to fetch resource.",
  "TypeError: The network connection was lost.",
  "The network connection was lost.",
  "TypeError: Cancelled",
  "TypeError: cancelled",
  "Cancelled",
  "cancelled",
  "NotAllowedError",
  /NotAllowedError/,
  "year && make not present in get-models-by-year-make-v3",
  // klaviyo signup form https://partsavatar.sentry.io/issues/4931919551/?project=1187556
  "InitializationError",
  // https://partsavatar.sentry.io/issues/4547780797/events/bcceaa8fbf8847cba09892cd29cb0556/?project=1187556&query=is%3Aunresolved&referrer=previous-event&sort=freq&statsPeriod=14d&stream_index=1
  // Occurs on windows with password manager extensions
  "Non-Error promise rejection captured with value:",
  "\"[object Object]\" is not valid JSON", // due to modheader extension
  "IDBFactory.open() called in an invalid security context", // Klaviyo error
  // https://partsavatar.sentry.io/issues/5654181306/?project=1187556&query=is%3Aunresolved+issue.priority%3A%5Bhigh%2C+medium%5D+firstSeen%3A-7d&referrer=issue-stream&statsPeriod=7d&stream_index=1
  "Failed to load static props", // this error occurs every time when new build is created and person with older version navigates & gets 404 & page reloads to be on the newer version
  "[GSI_LOGGER]: FedCM get() rejects with AbortError: signal is aborted without reason", // occurs when user clicks on screen and one tap closes
  "[GSI_LOGGER]: FedCM get() rejects with NetworkError: Error retrieving a token.", // occurs when browser setting doesn't allow third party sign in,
  "[GSI_LOGGER]: FedCM get() rejects with AbortError: The request has been aborted.", // occurs when user clicks on screen and one tap closes
  "[GSI_LOGGER]: User has opted out of using Google Sign In.",
  "PushEngage: App data is not available.", // It's coming due to network error from user side.
  "Failed to load Stripe.js", // occurs when Stripe fails to load due to network failure
  "PushEngage: Failed to fetch", // It's coming due to network or browser issue (browser cache, ad blockers etc.)
  "Load failed (partsavatar.ca)", // occurs when network drops during fetch,
  "PushEngage: Failed to fetch", // occurs when network drops during fetch,
  // https://partsavatar.sentry.io/issues/7638788962/?project=1187556
  // Safari Reader / Highlights content extraction on iOS
  "Error during extraction",
  "this.WrappedBody.rootNode",
  "updateAndCleanExtractedContent",
];

export const SENTRY_DENY_URLS = [
  // Facebook flakiness
  /graph\.facebook\.com/i,
  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Woopra flakiness
  /eatdifferent\.com\.woopra-ns\.com/i,
  /static\.woopra\.com\/js\/woopra\.js/i,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
];
